<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" [color]="environment.theme.spinnerColor" type="ball-clip-rotate" [fullScreen]="true">
<!--    <p style="color: white">{{ 'VIRTUAL-CONSULTANT.LOAD-MESSAGES' | translate }}</p>-->
</ngx-spinner>
<body>
    <div class="content">
        <div #div1 ngClass="div"
            [ngStyle]="{'width': showInspections ? '' : '20px', 'flex': showInspections ? '1' : ''}"
            [@slideInOut]="{value: animationState, params:{inWidth: inspectionWidth}}">
            <div *ngIf="showInspections" style="height: 100%; display: flex; flex-direction: column;">
                <div class="search-bar-vc">
                    <mat-icon class="vc-search-icon" matPrefix>search</mat-icon>
                    <input matInput class="vc-search-text" placeholder="Search..."
                        (ngModelChange)="onInspectionSearch($event)" [(ngModel)]="selectedInspection">
                </div>
                <div class="div3 flex-column scrollable">
                    <div *ngFor="let inspection of filteredInspections; let i = index"
                        [ngClass]="{'active-inspection-item': inspection.key === activeKey, 'inspection-item': inspection.key !== activeKey }"
                        (click)="loadInspectionMessages(inspection.key, inspection.latitude, inspection.longitude, inspection.tenantId, inspection.description, inspection.unreadMessages)">
                        <div [matBadge]="inspection.unreadMessages" matBadgeOverlap="true"
                            [matBadgeHidden]="inspection.unreadMessages == 0">
                            <label class="chat-title">
                                {{ inspection.description }}
                            </label>
                            <div class="inspection-info">
                                <label class="tenant-info">
                                    {{ inspection.tenantName }} | {{ inspection.farmName }} | {{ inspection.fieldName }}
                                </label>
                                <label class="date-time">
                                    {{ inspection.lastUpdated }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="expand-toggle-button flex-row" style="box-sizing: border-box;">
                    <div class="expand-toggle space-between-center">
                        <button mat-icon-button (click)="filterInspections()">
                            <mat-icon class="filter-icon">tune</mat-icon>
                        </button>
                        <label class="filter">{{ 'VIRTUAL-CONSULTANT.CLOSE-FIELD' | translate }} </label>
                        <button mat-icon-button (click)="toggleInspections(div1.offsetWidth)">
                            <mat-icon class="vc-expand-icon">keyboard_arrow_left</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="!showInspections" class="expand-toggle-big-button"
                (click)="toggleInspections(div1.offsetWidth)">
                <button mat-icon-button>
                    <mat-icon class="expand-inspections">keyboard_arrow_right</mat-icon>
                </button>
            </div>
        </div>

        <div #div2 class="div2 flex-column" style="flex: 1;">
            <div class="view-field-bt-heading-container flex-row" style="max-height: 5px;">
                <div class="farm-label">{{ farmField }}</div>
                <div class="view-pin-label">
                    <button  mat-button class="view-pin"  [disabled]="fieldNotFound" (click)="openField()" [ngClass]="{'disabled-view-pin': fieldNotFound, 'view-pin': !fieldNotFound }">
                        {{ 'VIRTUAL-CONSULTANT.VIEW-FIELD' | translate }}
                    </button>
                </div>
            </div>
            <div class="message-body flex-row">
                <div class="scrollableMessages-container">
                <div #scrollDiv class="scrollableMessages flex-column" style="flex: 1;">
                    <div *ngFor="let inspectionMessages1 of inspectionMessages; let i = index">
                        <div class="timestamp-container">
                            <label class="timestamp">{{ getDay(inspectionMessages1[0].time) }}</label>
                        </div>
                        <div *ngFor="let inspectionMessage of inspectionMessages1; let j = index" class="chat">
                            <div *ngIf="inspectionMessage.isUserSent" class="bubble you">
                                <div class="sender-name-you">{{ inspectionMessage.senderName }}
                                    <mat-icon matListIcon class="delete-icon"
                                        (click)="confirmDelete(inspectionMessage.key)">close</mat-icon>
                                </div>
                                <div *ngIf="inspectionMessage.text.length > 0" class="chat-container">
                                    {{ inspectionMessage.text }}
                                </div>
                                <div *ngIf="inspectionMessage.imageName.length > 0 && inspectionMessage?.imageUrl.length > 0" class="chat-container">
                                     <img [src]="inspectionMessage.imageUrl" (click)="openLightbox(inspectionMessage.imageUrl)" style="max-width: 200px; cursor: pointer;">
                                </div>
                                <div *ngIf="inspectionMessage.voiceName.length > 0" class="chat-container">
                                    <audio controls>
                                        <source src="{{ inspectionMessage.voiceUrl }}" type="audio/mp4">
                                    </audio>
                                </div>
                                <label class="time-label">{{ inspectionMessage.time | date:'HH:mm' }}</label>
                            </div>
                            <div *ngIf="!inspectionMessage.isUserSent" class="bubble me">
                                <div class="sender-name">{{ inspectionMessage.senderName }}</div>
                                <div *ngIf="inspectionMessage.text.length > 0" class="chat-container">
                                    {{ inspectionMessage.text }}
                                </div>
                                <div *ngIf="inspectionMessage.imageName.length > 0 && inspectionMessage?.imageUrl.length > 0" clas="msg-container">
                                    <img [src]="inspectionMessage.imageUrl" (click)="openLightbox(inspectionMessage.imageUrl)" style="max-width: 200px; cursor: pointer;">
                                    <!-- <ngx-gallery (imagesReady)="openImage()" [options]="galleryOptions" [images]="album"
                                        (previewOpen)="toggleInspections(div1.offsetWidth)"
                                        (previewClose)="toggleInspections(div1.offsetWidth)"></ngx-gallery> -->
                                </div>
                                <div *ngIf="inspectionMessage.voiceName.length > 0" class="chat-container">
                                    <audio controls preload="metadata">
                                        <source src="{{ inspectionMessage.voiceUrl }}" type="audio/mp4" >
                                    </audio>
                                </div>
                                <label class="time-label">{{ inspectionMessage.time | date:'HH:mm' }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <div>
                <div class="chat-bar">
                    <div class="upload-button">
                        <button mat-icon-button class="attach-button" (click)="fileInput.click()"
                            [disabled]="activeKey == '' ? true : null">
                            <mat-icon  class="button-icon-attach-audio">attach_file</mat-icon>
                            <input #fileInput type="file" (change)="onFileChanged($event)" accept=".jpg, .jpeg, .png"
                                style="display:none;" />
                        </button>
                    </div>

                    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="messageForm">
                        <mat-form-field floatLabel="never" appearance="outline" class="my-form-field">

                            <input matInput type="text" class="text-input"  formControlName="message" placeholder="Type a message"
                                [readonly]="activeKey == '' ? true : null">
                            <button class="send-button" matSuffix mat-icon-button aria-label="Clear"
                                type="submit" [disabled]="activeKey == '' ? true : null">
                                <mat-icon style="padding-bottom: 5px;">send</mat-icon>
                            </button>
                        </mat-form-field>
                    </form>
                    <div class="voice-note-button">
                        <button (click)="checkRecorder(true)" *ngIf="!buttonRecordingActive" id="recorder-button-start" mat-icon-button
                            [disabled]="activeKey == '' ? true : null">
                            <mat-icon class="button-icon-attach-audio">mic</mat-icon>
                        </button>

                        <button (click)="checkRecorder(false)" *ngIf="buttonRecordingActive" id="recorder-button-stop" mat-icon-button
                                [disabled]="activeKey == '' ? true : null">
                            <div class="icon-background">
                                <mat-icon class="stop-button-icon-attach-audio" id="animation">stop</mat-icon>
                            </div>

                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
